/* unplugin-vue-components disabled */import { render } from "./UserAgreement.vue?vue&type=template&id=7d19af13&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=7d19af13&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/txgy-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d19af13"]])

export default __exports__